import React, { Fragment, FunctionComponent } from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import tooltips from "./tooltips";
import {
  SectionTitle,
  Field,
  Label,
  LabelText,
  LabelIcon,
  Required,
  Select,
  Option,
  Error,
} from "../styles/edit-form-styles";

interface INumberOfPositionsProps {
  numberOfPositions: number;
  inputOnChange: () => void;
  errors: { number_of_positions?: string };
}

const NumberOfPositions: FunctionComponent<INumberOfPositionsProps> = ({
  numberOfPositions,
  inputOnChange,
  errors,
}) => {
  const numberOfPositionsOptions = Array.from({ length: 25 }, (_, i) => i + 1);

  return (
    <Fragment>
      <SectionTitle>Number Of Positions</SectionTitle>
      <Field data-test-id="number-of-positions">
        <Label htmlFor="number-of-positions">
          <LabelText>
            Number of Positions <Required>*</Required>
          </LabelText>
          <LabelIcon>
            <FontAwesomeIcon
              data-tip={tooltips.numberOfPositions}
              data-for="number-of-positions-tooltip"
              icon={faInfoCircle}
            />
            <ReactTooltip
              place="left"
              type="dark"
              effect="solid"
              aria-haspopup="true"
              id="number-of-positions-tooltip"
            />
          </LabelIcon>
        </Label>
        <Select
          error={!!errors.number_of_positions}
          onChange={inputOnChange}
          id="number-of-positions"
          name="numberOfPositions"
          value={numberOfPositions}
        >
          {numberOfPositionsOptions.map((cvLimit) => (
            <Option key={cvLimit} value={cvLimit}>
              {cvLimit}
            </Option>
          ))}
        </Select>
        {errors.number_of_positions && (
          <Error positionRelative>{errors.number_of_positions}</Error>
        )}
      </Field>
    </Fragment>
  );
};

NumberOfPositions.propTypes = {
  numberOfPositions: PropTypes.number.isRequired,
  inputOnChange: PropTypes.func.isRequired,
};

export default NumberOfPositions;
